import {combineReducers} from 'redux';

import rfqList from './rfq-list';
import removeRFQItem from './remove-rfq-item';

export const requestsForQuotationsReducer = combineReducers({
    rfqList,
    removeRFQItem,
});